// Styles
import styled from 'styled-components/macro'

// Core
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// Components, services, etc
import LandingHero from 'components/LandingHero'
import ProductsList from 'views/Landing/ProductsList'
import LandingOrdersList from 'views/Landing/LandingOrdersList'
import {
  isUserAuthenticatedSelector,
  recentOrdersStatusSelector,
  landingPageRecentOrdersSelector
} from 'selectors'
import {getRecentOrders} from 'actions/ordersActions'
import {LOADING} from 'constants/reduxStatuses'
import {trackMixpanelEvent} from 'services/mixpanel'
import {VISITED_LANDING_PAGE} from 'constants/mixpanelConstants'

// 3rd party
import CircularProgress from '@material-ui/core/CircularProgress'

const Landing = () => {
  const dispatch = useDispatch()
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector)
  const recentOrdersStatus = useSelector(recentOrdersStatusSelector)
  const isLoading = recentOrdersStatus === LOADING
  const recentOrders = useSelector(landingPageRecentOrdersSelector)

  useEffect(() => {
    if (isUserAuthenticated) {
      dispatch(getRecentOrders())
    }
  }, [isUserAuthenticated, dispatch])

  // We only want to fire this once on page load
  useEffect(() => {
    // @ts-ignore this function need a second argument, can we pass {}
    trackMixpanelEvent(VISITED_LANDING_PAGE)
  }, [])

  return (
    <Landing.Styled>
      <LandingHero />
      {isLoading ? (
        <div className='loading-wrap'>
          {/* inner div needed for IE11 */}
          <div>
            <CircularProgress size={100} />
          </div>
        </div>
      ) : isUserAuthenticated && recentOrders.length > 0 ? (
        <LandingOrdersList />
      ) : (
        <ProductsList />
      )}
    </Landing.Styled>
  )
}

Landing.Styled = styled.div<{headerHeight?: number}>`
  .loading-wrap {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    margin-top: ${({headerHeight = 0}) => -headerHeight ?? 0}px;
    min-height: 386px;
    height: 385px;

    /* inner div needed for IE11 */
    > div {
      display: flex;
      width: 48px;
    }
  }
`

export default Landing
